module.exports = __webpack_public_path__ + "static/media/CoreCapital_SAFI_.d0360698.png";